<template>
    <b-dropdown v-model="localValue" aria-role="list" :mobile-modal="false" class="ls-dropdown">
        <button
            slot="trigger"
            class="button is-white ls-dropdown--button"
            test-id="ls_dropdown"
            :disabled="!options.length"
        >
            <span :class="{ 'ls-dropdown--is-selected': localValue }"> {{ getLabel }}</span>
            <img src="./assets/arrow.svg" />
        </button>

        <b-dropdown-item
            v-for="option in options"
            :key="option.value"
            :value="option.value"
            :disabled="option.disabled || localValue === option.value"
            aria-role="listitem"
            :test-id="`ls_dropdown_item_${option.value}`"
        >
            <component :is="option.component" v-if="option.component" v-bind="option.props" />
            <span v-else>{{ option.label }}</span>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import VueTypes from 'vue-types';
import { lsPropTypeHelpers, lsTrackingService } from 'ls-vue-common';
import _ from 'lodash';

export default {
    name: 'LsDropdown',
    props: {
        value: VueTypes.any.isRequired,
        options: VueTypes.arrayOf(
            VueTypes.shape({
                label: VueTypes.string,
                value: VueTypes.any.isRequired,
                component: VueTypes.any,
                props: VueTypes.object,
                disabled: VueTypes.bool,
            }).loose
        ).isRequired,
        trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                lsTrackingService.track({
                    event: 'click',
                    target: this.trackId,
                    data: { value },
                });
                this.$emit('input', value);
            },
        },
        getLabel() {
            return _.get(_.find(this.options, { value: this.localValue }), 'label', '- Select -');
        },
    },
};
</script>

<style lang="scss">
.ls-dropdown {
    width: 100%;
    div {
        width: 100%;
    }

    .ls-dropdown--is-selected {
        color: $secondary-dark;
    }

    .ls-dropdown--button {
        width: 100%;
        justify-content: space-between;
        height: 36px;
        border-radius: 2px 2px 0 0;
        box-shadow: $box-shadow;
        padding-left: 15px;
    }

    .dropdown-menu {
        margin-top: -5px;
    }

    .dropdown-content {
        border-radius: 0 0 4px 4px;
        box-shadow: $box-shadow;
    }

    .dropdown-item {
        font-size: $size-5;
        padding: 15px;
        user-select: none;
        outline: none;
        opacity: 1 !important;
    }

    .dropdown-item.is-active {
        color: $secondary;
        background-color: $white;
        font-weight: $semi-bold;
        span {
            font-weight: $semi-bold;
        }
    }

    .dropdown-item:not(:last-of-type):before {
        content: '';
        position: absolute;
        left: 2.5%;
        bottom: 0;
        height: 1px;
        width: 95%;
        border-bottom: 1px solid $secondary-light;
    }
}
</style>
